import { create } from 'zustand';

import { isOnline, watchOnline } from '../data/connectivityData';

interface ConnectivityState {
  online: boolean;
  refresh: () => boolean;
}

export const useConnectivityStore = create<ConnectivityState>((set) => ({
  // Optimistic until the first check, matching ConnectivityHandler.
  online: true,
  refresh: () => {
    const online = isOnline();
    set({ online });
    return online;
  },
}));

let started = false;

export function startConnectivityWatch(): void {
  if (started) return;
  started = true;
  useConnectivityStore.getState().refresh();
  watchOnline((online) => {
    useConnectivityStore.setState({ online });
    if (online) {
      void import('@/app/remote_config/handler/remoteConfigStore').then(({ useRemoteConfigStore }) => {
        void useRemoteConfigStore.getState().refresh();
      });
    }
  });
}
